
<div class="generalPage" aria-label="helpannotations" role="main">
  <div class="pr-22 content-container pb-0 print-all-content" [ngClass]="IsRightPanel?'pt-0':''">
    <h1 class="generalHeader margin-0 content-blue bold itcHeavyFont pb-heading" role="heading">{{annot_header}}</h1>
    <p class="answer font-16 content-blue width-100 pb-heading" [innerHTML]="annot_description"></p>
    <p class="answer font-24 content-blue width-100 mb-invert-12 bold pb-heading" role="heading">{{annot_para1header}}</p>
    <p class="answer font-16 content-blue width-100" [innerHTML]="annot_para1body"></p>
    <p class="answer font-24 content-blue width-100 mb-invert-12 bold pb-heading" role="heading">{{annot_para2header}}</p>
    <p class="answer font-20 content-blue width-100 mb-invert-12 bold pb-heading" role="heading">{{annot_para2SubHeader}}</p>
    <p class="answer font-16 content-blue width-100" [innerHTML]="annot_para2body"></p>
    <p class="answer font-16 content-blue width-100" [innerHTML]="annot_para2BodyList"></p>
    <p class="answer font-16 content-blue width-100" [innerHTML]="annot_para2BodyEnd"></p>
    <p class="answer font-20 content-blue width-100 mb-invert-12 bold pb-heading" role="heading">{{annot_para3SubHeader}}</p>
    <p class="answer font-16 content-blue width-100" [innerHTML]="annot_para3Body"></p>
    <p class="answer font-20 content-blue width-100 mb-invert-12 bold pb-heading" role="heading">{{annot_para4SubHeader}}</p>
    <p class="answer font-16 content-blue width-100" [innerHTML]="annot_para4Body"></p>
    <p class="answer font-16 content-blue width-100" [innerHTML]="annot_para4BodyList"></p>
  </div>
</div>

